<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <h3>Thông tin phòng ban</h3>
                    </div>
                </div>

                <div class="vx-row mt-6">
                    <!--Branch-->
                    <div class="vx-col md:w-1/2 w-full">
                        <label class="vs-input--label">Chi nhánh</label>
                        <span class="text-sm text-danger">*</span>
                        <v-select
                            class="w-full"
                            :clearable="false"
                            v-model="selectedBranch"
                            :options="branchOptions"
                            name="branch"
                            v-validate="'required'" :disabled="isUpdate">
                            <span class="text-danger text-sm">{{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                    </div>
                    <!--Department-->
                    <div class="vx-col md:w-1/2 w-full md:mt-0 mt-2">
                        <label class="vs-input--label">Tên phòng ban</label>
                        <span class="text-sm text-danger">*</span>
                        <vs-input
                            class="w-full"
                            v-model="departmentInfo.departmentName"
                            name="departmentName"
                            v-validate="'required'">
                            <span class="text-danger text-sm"> {{ $t('menuOrganization.noOption') }}</span>
                        </vs-input>
                        <span class="text-danger text-sm">{{ errors.first('departmentName') }}</span>
                    </div>
                </div>

                <div class="vx-row mt-6">
                    <div class="vx-col w-full float-right">
                        <div class="mt-4 flex flex-wrap mb-5">
                            <vs-button
                                class="ml-auto mt-2"
                                @click="saveChanges"
                                :disable="!validateForm">
                                {{ `${isUpdate ? 'Cập nhật' : 'Tạo mới'}` }}
                            </vs-button>
                            <vs-button
                                class="ml-4 mt-2"
                                type="border"
                                color="warning"
                                onclick="history.back()" v-if="!branchId">
                                Quay lai
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select';

export default {
    components: {
        vSelect,
    },
    props: {
        departmentId: {
            type: Number,
            required: true
        },
        branchId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            branchOptions: [],
            selectedBranchValue: null,
            isUpdate: false,
            departmentInfo: {
                departmentName: null,
            }
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any();
        },
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                if (!obj) return;
                return {
                    label: obj.label,
                    value: obj.value
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
            },
        }
    },
    created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        let departmentId = this.departmentId ? this.departmentId : this.$route.query.departmentId;
        let branchId = this.branchId ? this.branchId : this.$route.query.branchId;
        if (departmentId && branchId) {
            this.selectedBranchValue = parseInt(branchId)
            this.isUpdate = true;
            this.findById(parseInt(departmentId))
        }
    },
    methods: {
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            this.departmentInfo.organizationBranchId = this.selectedBranchValue;

            this.$vs.loading();
            this.$crm.post('/department/create', this.departmentInfo).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: `${this.isUpdate ? 'Cập nhật ' : 'Tạo mới '} phòng ban thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                if (this.branchId) {
                    this.$eventBus.$emit("update-department-success", {});
                } else {
                    this.$router.push('/user/manage-department');
                }
            }).catch((err) => {
                this.$vs.loading.close();
                if (this.branchId) {
                    this.$eventBus.$emit("update-department-success", {});
                }
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        findById(departmentId) {
            this.$vs.loading();
            this.$crm.get(`/department/find-by-id?id=${departmentId}`).then(res => {
                this.departmentInfo = res.data;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    },

}
</script>

<style lang="scss">

</style>
